module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/lion-mobile-english.24ab248f.jpg";